import React from 'react';
import FieldTextarea from "./FieldTextarea";
import FieldFile from "./FieldFile";
import FieldText from "./FieldText";
import FieldCheckbox from "./FieldCheckbox";


class OrderPropItem extends React.Component {
    render() {

        switch (this.props.item.type) {
            case 'TEXTAREA':
                return (
                    <FieldTextarea item={this.props.item}/>
                );
                // eslint-disable-next-line
                break;
            case 'FILE':
                return (
                    <FieldFile item={this.props.item}/>
                );
                // eslint-disable-next-line
                break;
            case 'CHECKBOX':
                return (
                    <FieldCheckbox item={this.props.item}/>
                );
                // eslint-disable-next-line
                break;
            default:
                //TEXT
                return (
                    <FieldText item={this.props.item}/>
                );
        }
    }
}

export default OrderPropItem;